import Suspense from "components/shared/Suspense";
import useMount from "hooks/useMount";
import { lazy } from "react";
import useCurrentUserId from "hooks/user/useCurrentUserId";

const ListUserReadCount = lazy(() => import("./ListUserReadCount"));

export type ListUserReadCountLoaderSize = "sm" | "md" | "lg";
export default function ListUserReadCountLoader({
  listId,
  count,
  size = "sm",
}: {
  listId: number;
  count: number;
  size: ListUserReadCountLoaderSize;
}) {
  const userId = useCurrentUserId();
  const mounted = useMount();

  if (!userId || !mounted) {
    return <></>;
  }

  return (
    <Suspense>
      <ListUserReadCount
        userId={userId}
        listId={listId}
        count={count}
        size={size}
      />
    </Suspense>
  );
}
